import { render, staticRenderFns } from "./ItemsView.vue?vue&type=template&id=3e854d2c&scoped=true&"
import script from "./ItemsView.vue?vue&type=script&lang=js&"
export * from "./ItemsView.vue?vue&type=script&lang=js&"
import style0 from "./ItemsView.vue?vue&type=style&index=0&id=3e854d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e854d2c",
  null
  
)

export default component.exports